/**
 * Check for is client device a touch device or not.
 * @return {boolean} true if is touch device, else false
 */
const isTouchDevice = () => {
    try {
        document.createEvent('TouchEvent');
        return true;
    }
    catch (e) {
        return false;
    }
};
export default isTouchDevice;
//# sourceMappingURL=isTouchDevice.js.map